import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'helpers/mobx'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React, { FC } from 'react'

const DocumentHead: FC<Partial<IDocumentHead>> = props => (
  <>
    <TrackContentPageView pageTitle={props.title || ''} />
    <BaseDocumentHead {...props} />
  </>
)

export default inject(
  (
    _store,
    {
      blackFridayTitle,
      blackFridayMeta,
    }: { blackFridayTitle: string; blackFridayMeta: string },
  ) => {
    return {
      title: blackFridayTitle,
      description: blackFridayMeta,
      robots: 'index, follow',
      customTitleTemplate: true,
      allowEmptyHreflangs: false,
    }
  },
)(DocumentHead)
